"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames4 = _interopRequireDefault(require("classnames"));

var _KeyboardUtils = require("../../util/KeyboardUtils");

var _PropUtils = require("../../util/PropUtils");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source))).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

/**
 * @class Icon
 * @desc A component for displaying an icon by itself or next to next.
 *
 * @param {string} [data-id="icon"]
 *     Defines the "data-id" for top-level HTML container.
 * @param {string} [iconName]
 *     The name of the icon.
 * @param {string} [className]
 *     Extra CSS class(s) applied to the top-level HTML container.
 * @param {Icon.iconColors} [color]
 *     Use one of our semantic colors on the icon.
 * @param {Icon.iconTypes} [type]
 *     Set to Icon.iconTypes.LEADING or Icon.iconTypes.INLINE to either provide extra spacing or not.
 * @param {string} [title]
 *     Title for the label within a stack gap.
 * @param {Icon.iconSizes} [iconSize]
 *     Size of the icon, XS, SM, MD, LG, XL, or XXL
 *     When iconSize is defined there needs to be 2 child elements for it to look right.
 *     Example on how to use the new props below
 *
 * @example
 * <Icon iconName="cog">
 *    Some text or other content that appears next to the icon.
 * </Icon>
 *
 * <Icon iconName="globe" iconSize={iconSizes.XL} title="hello">'
 *       <Stack gap="ZERO">
 *           <Text type="value">5 maximum</Text>
 *           <Text type="value">Sandbox only</Text>
 *       </Stack>
 *   </Icon>
 *
 */

/**
 * @enum {string}
 * @alias Icon.iconsizes
 */
var iconSizes = {
  /** sm */
  SM: "sm",

  /** md */
  MD: "md",

  /** lg */
  LG: "lg",

  /** xl */
  XL: "xl",

  /** xxl */
  XXL: "xxl",

  /** alias for xxl */
  XX: "xxl"
};
/**
 * @enum {string}
 * @alias Icon.iconTypes
 * @description Simple or block-level icon
 */

var iconTypes = {
  /** inline */
  INLINE: "inline",

  /** leading */
  LEADING: "leading"
};
/**
 * @enum {string}
 * @alias Icon.iconColors
 * @description Simple or block-level icon
 */

var iconColors = {
  /** error */
  ERROR: "error",

  /** warning */
  WARNING: "warning",

  /** success */
  SUCCESS: "success"
};
var Icon = (0, _KeyboardUtils.withFocusOutline)(function (_ref) {
  var _classnames, _context2, _classnames3;

  var className = _ref.className,
      color = _ref.color,
      containerClassName = _ref.containerClassName,
      children = _ref.children,
      dataId = _ref["data-id"],
      iconSize = _ref.iconSize,
      onClick = _ref.onClick,
      title = _ref.title,
      type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "color", "containerClassName", "children", "data-id", "iconSize", "onClick", "title", "type"]);
  //using camelCase instead of BEM standard because icon- is reserved by iconfont
  var baseClassName = "iconComponent";
  var graphicClassName = (0, _classnames4.default)(["".concat(baseClassName, "__graphic")], (0, _PropUtils.getIconClassName)(props), className, (_classnames = {}, (0, _defineProperty3.default)(_classnames, "".concat(baseClassName, "__graphic--size-sm"), iconSize === iconSizes.SM), (0, _defineProperty3.default)(_classnames, "".concat(baseClassName, "__graphic--size-md"), iconSize === iconSizes.MD), (0, _defineProperty3.default)(_classnames, "".concat(baseClassName, "__graphic--size-lg"), iconSize === iconSizes.LG), (0, _defineProperty3.default)(_classnames, "".concat(baseClassName, "__graphic--size-xl"), iconSize === iconSizes.XL), (0, _defineProperty3.default)(_classnames, "".concat(baseClassName, "__graphic--size-xxl"), iconSize === iconSizes.XXL), _classnames));
  var onClickProps = onClick ? _objectSpread({
    onClick: onClick
  }, (0, _PropUtils.getClickableA11yProps)(onClick)) : {};

  if (type !== iconTypes.LEADING && !children || type === iconTypes.INLINE) {
    var _context, _classnames2;

    return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
      "data-id": dataId,
      className: (0, _classnames4.default)(className, containerClassName, (0, _PropUtils.getIconClassName)(props), (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, "".concat(baseClassName, "--clickable"), onClick), (0, _defineProperty3.default)(_classnames2, "".concat(baseClassName, "--size-sm"), iconSize === iconSizes.SM), (0, _defineProperty3.default)(_classnames2, "".concat(baseClassName, "--size-md"), iconSize === iconSizes.MD), (0, _defineProperty3.default)(_classnames2, "".concat(baseClassName, "--size-lg"), iconSize === iconSizes.LG), (0, _defineProperty3.default)(_classnames2, "".concat(baseClassName, "--size-xl"), iconSize === iconSizes.XL), (0, _defineProperty3.default)(_classnames2, "".concat(baseClassName, "--size-xxl"), iconSize === iconSizes.XXL), (0, _defineProperty3.default)(_classnames2, (0, _concat.default)(_context = "".concat(baseClassName, "--")).call(_context, color), color), _classnames2))
    }, onClickProps));
  }

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames4.default)(containerClassName, baseClassName, "icon", (_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, "".concat(baseClassName, "--clickable"), onClick), (0, _defineProperty3.default)(_classnames3, (0, _concat.default)(_context2 = "".concat(baseClassName, "--")).call(_context2, color), color), _classnames3)),
    "data-id": dataId
  }, onClickProps), /*#__PURE__*/_react.default.createElement("div", {
    className: graphicClassName,
    "data-id": "".concat(dataId, "-graphic")
  }), (children || title) && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(baseClassName, "__content"),
    "data-id": "".concat(dataId, "-content")
  }, title && /*#__PURE__*/_react.default.createElement("label", null, title), children));
});
Icon.displayName = "Icon";
Icon.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  iconName: _propTypes.default.string,
  textType: _propTypes.default.string,
  title: _propTypes.default.string,
  type: _propTypes.default.oneOf((0, _values.default)(iconTypes)),
  iconSize: _propTypes.default.oneOf((0, _values.default)(iconSizes))
};
Icon.defaultProps = {
  "data-id": "icon"
};
Icon.iconSizes = iconSizes;
Icon.iconTypes = iconTypes;
Icon.iconColors = iconColors;
var _default = Icon;
exports.default = _default;
module.exports = exports["default"];